import isMobile from '@/utils/is-mobile';

import type { Notifications } from './types';

const title = 'RG.FM';

const email = 'suporte@rgfm.com.br';

const repository = 'https://github.com/usabit';

const messages = {
  app: {
    crash: {
      title: 'Oooops... Desculpe, parece que algo deu errado. Você pode:',
      options: {
        email: `entrar em contato com o autor por este email - ${email}`,
        reset: 'Clique aqui para reiniciar o aplicativo',
      },
    },
  },
  loader: {
    fail: 'Hmmmmm, algo deu errado durante o processo de carregamento deste componente... Talvez tentar mais tarde seja a melhor "deia", there is something wrong with this component loading process...',
  },
  images: {
    failed: 'algo deu errado durante o carregamento da imagem :(',
  },
  404: 'E aí, tudo bem? O que você está procurando?',
};

const dateFormat = 'MMMM DD, YYYY';

const notifications: Notifications = {
  options: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    autoHideDuration: 6000,
  },
  maxSnack: isMobile ? 3 : 4,
};

const loader = {
  // no more blinking in your app
  delay: 300, // if your asynchronous process is finished during 300 milliseconds you will not see the loader at all
  minimumLoading: 700, // but if it appears, it will stay for at least 700 milliseconds
};

const defaultMetaTags = {
  image: '/cover.png',
  description: 'Player RG.FM Music Branding',
};
const giphy404 = 'https://giphy.com/embed/xTiN0L7EW5trfOvEk0';

export {
  loader,
  notifications,
  dateFormat,
  messages,
  repository,
  email,
  title,
  defaultMetaTags,
  giphy404,
};
